var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-button",on:{"click":function($event){return _vm.$emit('click', _vm.id)}}},[_c('div',{staticClass:"filter-button__icon"},[(_vm.iconSrc)?_c('img',{attrs:{"src":_vm.iconSrc,"alt":"icon"}}):_vm._e()]),_c('div',{staticClass:"filter-button__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }